// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .cdk-overlay-pane {
  max-width: 90vw !important;
}
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container {
  border-radius: 16px !important;
  overflow: hidden !important;
  padding: 0 !important;
}
::ng-deep .cdk-overlay-pane .mdc-dialog__container {
  border-radius: 16px !important;
  overflow: hidden !important;
}
::ng-deep .cdk-overlay-pane .mdc-dialog__surface {
  border-radius: 16px !important;
  overflow: hidden !important;
  padding: 0 !important;
}

.change-password-container {
  display: flex;
  flex-direction: column;
  min-width: 480px;
  max-width: 620px;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}
@media (max-width: 600px) {
  .change-password-container {
    min-width: unset;
    width: 100%;
  }
}

.change-password-header {
  cursor: move;
}
.change-password-header[dir=rtl] .change-password-header-left {
  flex-direction: row-reverse;
}
.change-password-header[dir=rtl] .ctx-header-title {
  text-align: right;
}
.change-password-header[dir=ltr] .ctx-header-title {
  text-align: left;
}
.change-password-header .change-password-header-left {
  position: relative;
  z-index: 1;
  min-width: 0;
}
.change-password-header .header-close-btn {
  width: 30px !important;
  height: 30px !important;
  line-height: 30px !important;
  min-width: unset !important;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.75);
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px !important;
  transition: background 0.15s, color 0.15s;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative;
  z-index: 1;
}
.change-password-header .header-close-btn ::ng-deep .mat-mdc-button-touch-target {
  width: 30px !important;
  height: 30px !important;
}
.change-password-header .header-close-btn mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  line-height: 17px;
}
.change-password-header .header-close-btn:hover {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}

.change-password-body {
  padding: 20px 24px 8px;
  background: #ffffff;
}

.change-password-content {
  padding: 0 !important;
  max-height: unset !important;
  overflow: visible !important;
}

.change-password-actions {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 14px 24px 18px !important;
  border-top: 1px solid #e2e8f0;
  gap: 12px;
  background: #ffffff;
}
.change-password-actions button {
  min-width: 110px;
  height: 38px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px;
}
.change-password-actions button mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  line-height: 17px;
}

.change-password-dialog-content {
  min-height: 120px;
  max-height: 60vh;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.02);
}
.change-password-dialog-content .change-password-form {
  display: block;
}
.change-password-dialog-content .change-password-form-inner {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.change-password-dialog-content .form-section {
  background: #fff;
  border-radius: 10px;
  padding: 12px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.change-password-dialog-content .form-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.7);
  letter-spacing: 0.01em;
}
.change-password-dialog-content .form-section-title mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  opacity: 0.85;
}
.change-password-dialog-content .form-section-fields.password-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 20px;
  align-items: start;
}

.change-password-dialog-actions .btn-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-inline-end: 6px;
}

.mr-1 {
  margin-right: 8px;
}

@media (max-width: 600px) {
  .change-password-dialog-content .form-section-fields.password-grid {
    grid-template-columns: 1fr;
  }
  .change-password-actions {
    padding: 10px 16px 16px !important;
    flex-wrap: wrap;
  }
}
@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.6);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/Setup/change-password/change-password.component.scss"],"names":[],"mappings":"AAUA;EACI,0BAAA;AATJ;AAWI;EACI,8BAAA;EACA,2BAAA;EACA,qBAAA;AATR;AAYI;EACI,8BAAA;EACA,2BAAA;AAVR;AAaI;EACI,8BAAA;EACA,2BAAA;EACA,qBAAA;AAXR;;AAeA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAlCM;EAmCN,mBA9BK;EA+BL,gBAAA;EACA,2CAAA;AAZJ;AAcI;EAVJ;IAWQ,gBAAA;IACA,WAAA;EAXN;AACF;;AAcA;EACI,YAAA;AAXJ;AAcQ;EACI,2BAAA;AAZZ;AAeQ;EACI,iBAAA;AAbZ;AAkBQ;EACI,gBAAA;AAhBZ;AAoBI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AAlBR;AAqBI;EACI,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,gCAAA;EACA,oCAAA;EACA,6BAAA;EACA,yCAAA;EACA,qBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,kBAAA;EACA,UAAA;AAnBR;AAqBQ;EACI,sBAAA;EACA,uBAAA;AAnBZ;AAsBQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AApBZ;AAuBQ;EACI,qCAAA;EACA,WAAA;AArBZ;;AA0BA;EACI,sBAAA;EACA,mBA5GM;AAqFV;;AA0BA;EACI,qBAAA;EACA,4BAAA;EACA,4BAAA;AAvBJ;;AA0BA;EACI,wBAAA;EACA,8BAAA;EACA,8BAAA;EACA,yCAAA;EACA,kCAAA;EACA,6BAAA;EACA,SAAA;EACA,mBA7HM;AAsGV;AAyBI;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,QAAA;AAvBR;AAyBQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAvBZ;;AA4BA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;AAzBF;AA2BE;EACE,cAAA;AAzBJ;AA4BE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA1BJ;AA6BE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,qCAAA;AA3BJ;AA8BE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AA5BJ;AA8BI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AA5BN;AAgCE;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EACA,kBAAA;AA9BJ;;AAmCE;EACE,qBAAA;EACA,sBAAA;EACA,sBAAA;AAhCJ;;AAoCA;EACE,iBAAA;AAjCF;;AAoCA;EAEI;IACE,0BAAA;EAlCJ;EAsCA;IACE,kCAAA;IACA,eAAA;EApCF;AACF;AAuCA;EACI;IACI,UAAA;IACA,qBAAA;EArCN;EAwCE;IACI,UAAA;IACA,mBAAA;EAtCN;AACF;AAyCA;EACI;IACI,UAAA;IACA,0BAAA;EAvCN;EA0CE;IACI,UAAA;IACA,wBAAA;EAxCN;AACF","sourcesContent":["$primary: var(--color-primary);\n$primary-light: var(--color-primary-tint);\n$surface: #ffffff;\n$bg: #f7f4ec;\n$border: #e2e8f0;\n$text: #1e293b;\n$text-muted: #64748b;\n$radius: 16px;\n$radius-sm: 8px;\n\n::ng-deep .cdk-overlay-pane {\n    max-width: 90vw !important;\n\n    .mat-mdc-dialog-container {\n        border-radius: $radius !important;\n        overflow: hidden !important;\n        padding: 0 !important;\n    }\n\n    .mdc-dialog__container {\n        border-radius: $radius !important;\n        overflow: hidden !important;\n    }\n\n    .mdc-dialog__surface {\n        border-radius: $radius !important;\n        overflow: hidden !important;\n        padding: 0 !important;\n    }\n}\n\n.change-password-container {\n    display: flex;\n    flex-direction: column;\n    min-width: 480px;\n    max-width: 620px;\n    background: $surface;\n    border-radius: $radius;\n    overflow: hidden;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n\n    @media (max-width: 600px) {\n        min-width: unset;\n        width: 100%;\n    }\n}\n\n.change-password-header {\n    cursor: move;\n\n    &[dir='rtl'] {\n        .change-password-header-left {\n            flex-direction: row-reverse;\n        }\n\n        .ctx-header-title {\n            text-align: right;\n        }\n    }\n\n    &[dir='ltr'] {\n        .ctx-header-title {\n            text-align: left;\n        }\n    }\n\n    .change-password-header-left {\n        position: relative;\n        z-index: 1;\n        min-width: 0;\n    }\n\n    .header-close-btn {\n        width: 30px !important;\n        height: 30px !important;\n        line-height: 30px !important;\n        min-width: unset !important;\n        flex-shrink: 0;\n        color: rgba(255, 255, 255, 0.75);\n        background: rgba(255, 255, 255, 0.1);\n        border-radius: 8px !important;\n        transition: background 0.15s, color 0.15s;\n        padding: 0 !important;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        position: relative;\n        z-index: 1;\n\n        ::ng-deep .mat-mdc-button-touch-target {\n            width: 30px !important;\n            height: 30px !important;\n        }\n\n        mat-icon {\n            font-size: 17px;\n            width: 17px;\n            height: 17px;\n            line-height: 17px;\n        }\n\n        &:hover {\n            background: rgba(255, 255, 255, 0.22);\n            color: #fff;\n        }\n    }\n}\n\n.change-password-body {\n    padding: 20px 24px 8px;\n    background: $surface;\n}\n\n.change-password-content {\n    padding: 0 !important;\n    max-height: unset !important;\n    overflow: visible !important;\n}\n\n.change-password-actions {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    padding: 14px 24px 18px !important;\n    border-top: 1px solid $border;\n    gap: 12px;\n    background: $surface;\n\n    button {\n        min-width: 110px;\n        height: 38px;\n        font-size: 13px;\n        font-weight: 600;\n        letter-spacing: 0.04em;\n        border-radius: $radius-sm !important;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        gap: 6px;\n\n        mat-icon {\n            font-size: 17px;\n            width: 17px;\n            height: 17px;\n            line-height: 17px;\n        }\n    }\n}\n\n.change-password-dialog-content {\n  min-height: 120px;\n  max-height: 60vh;\n  overflow-y: auto;\n  background: rgba(0, 0, 0, 0.02);\n\n  .change-password-form {\n    display: block;\n  }\n\n  .change-password-form-inner {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .form-section {\n    background: #fff;\n    border-radius: 10px;\n    padding: 12px 16px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n    border: 1px solid rgba(0, 0, 0, 0.06);\n  }\n\n  .form-section-title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0 0 12px 0;\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: rgba(0, 0, 0, 0.7);\n    letter-spacing: 0.01em;\n\n    mat-icon {\n      font-size: 22px;\n      width: 22px;\n      height: 22px;\n      opacity: 0.85;\n    }\n  }\n\n  .form-section-fields.password-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px 20px;\n    align-items: start;\n  }\n}\n\n.change-password-dialog-actions {\n  .btn-spinner {\n    display: inline-block;\n    vertical-align: middle;\n    margin-inline-end: 6px;\n  }\n}\n\n.mr-1 {\n  margin-right: 8px;\n}\n\n@media (max-width: 600px) {\n  .change-password-dialog-content {\n    .form-section-fields.password-grid {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .change-password-actions {\n    padding: 10px 16px 16px !important;\n    flex-wrap: wrap;\n  }\n}\n\n@keyframes popIn {\n    from {\n        opacity: 0;\n        transform: scale(0.6);\n    }\n\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n@keyframes fadeUp {\n    from {\n        opacity: 0;\n        transform: translateY(8px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
